import {Route, Switch} from 'react-router-dom';
import './App.css';

import Navbar from './components/navbar/Navbar';
import Home from './components/home/Home';
import Contact from './components/contact/Contact';
import News from './components/news/News';
import Album from './components/music/album/Album';
import Videos from './components/music/video/Videos';
import Tour from './components/tour/Tour';
import Footer from './components/footer/Footer';
import NewsDetail from './components/news/new detail/NewsDetail';

function App() {
  return (
    <div className="app">
      <Navbar />
      <Switch>
        {/* left navbar */}
        <Route exact path="/news" component={News} />
        <Route exact path="/music" component={Album} />
        <Route exact path="/videos" component={Videos} />

        {/* right navbar */}
        <Route exact path="/tour" component={Tour} />
        <Route exact path="/contact" component={Contact} />
        <Route exact path="/katepilla" component={NewsDetail} />
        
        {/* home */}
        <Route path="/" component={Home} exact />
      </Switch>
      <Footer />
    </div>
  );
}

export default App;
